export default __webpack_public_path__ + "static/media/confetti 1.3d31a58a.svg";